import React from 'react'
import clsx from 'clsx'
import { useFormContext } from 'react-hook-form'
import { RatingContext } from '../../utils/RatingContext'
import styles from '../../assets/styles/styles.module.css'
import { TEXT } from '../../i18n/text'
import { useSpring, animated } from 'react-spring'
import { MAX_FEEDBACK_LENGTH, normalizeFeedback } from '../../utils/feedbackValidation'

import { PHeading, PText, PTextareaWrapper } from '@porsche-design-system/components-react'
import { StarRating } from './StarRating'

export const RatingDefault = (): React.ReactElement => {
    const language = React.useContext(RatingContext).language
    const rating = React.useContext(RatingContext).rating
    const { register, formState: { errors } } = useFormContext()
    const [ratingUnder4, setRatingUnder4] = React.useState(false);

    React.useEffect(()=> {
        if(rating < 4 && rating !== 0) {
            setRatingUnder4(true)
        } else {
            setRatingUnder4(false)
        }
    }, [rating])

    const fadeIn = useSpring({
        opacity: ratingUnder4 ? 1 : 0,
        height: ratingUnder4 ? 70 : 0
    })

    const fadeOut = useSpring({
        opacity: ratingUnder4 ? 0 : 1,
        height: ratingUnder4 ? 0 : 70
    })

    return (
        <div className={clsx(styles.content, styles.contentFullHeight)}>
            <animated.div style={fadeOut}>
                <PText className={styles.spacingL}>{TEXT[language].text}</PText>
            </animated.div>
            <div className={clsx(styles.flexContainer, styles.flexAlignCenter, styles.spacingL)}>
                <PHeading tag='h5' size='small' className={styles.feedbackTitle}>
                    {TEXT[language].feedback}
                </PHeading>
                <div className={styles.foreGround}>
                    <StarRating />
                </div>
            </div>
            <animated.div style={fadeIn}>
                <PText>{TEXT[language].reasons}</PText>
            </animated.div>
            <PTextareaWrapper className={clsx(styles.spacingL, styles.smaller)} hideLabel>
                <textarea
                    {...register("comment", {
                        maxLength: {
                            value: MAX_FEEDBACK_LENGTH,
                            message: TEXT[language].feedbackErrorTooLong
                        },
                        setValueAs: normalizeFeedback
                    })}
                    placeholder={TEXT[language].textareaPlaceholder} />
                <PText size="xx-small">{TEXT[language].textareaHint}</PText>
                {errors.comment?.message && (
                    <PText color='brand' size="xx-small" className={styles.fieldError}>
                        {String(errors.comment.message)}
                    </PText>
                )}
            </PTextareaWrapper>
        </div>
    )
}
